const RECORDING_FILE_PREFIX = "interview-recording";
const DEFAULT_RECORDING_EXTENSION = ".webm";
const RECORDING_EXTENSION_BY_MIME: Record<string, string> = {
  "audio/webm": ".webm",
  "audio/ogg": ".ogg",
  "audio/wav": ".wav",
  "audio/x-wav": ".wav",
  "audio/mpeg": ".mp3",
  "audio/mp4": ".m4a",
};
const CANDIDATE_SLUG_MAX_LENGTH = 32;
const INTERVIEW_ID_SHORT_LENGTH = 8;

export function resolveRecordingExtension(contentType: string | null): string {
  const base = contentType?.split(";")[0]?.trim().toLowerCase() ?? "";
  return RECORDING_EXTENSION_BY_MIME[base] ?? DEFAULT_RECORDING_EXTENSION;
}

export function toFileNameSlug(value: string | null): string | null {
  if (!value) return null;
  const slug = value
    .trim()
    .replace(/[\\/:*?"<>|]+/g, "")
    .replace(/\s+/g, "-")
    .slice(0, CANDIDATE_SLUG_MAX_LENGTH);
  return slug.length > 0 ? slug : null;
}

export function toTimestampSlug(iso: string | null): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}-${pad(date.getHours())}${pad(date.getMinutes())}`;
}

export function buildRecordingFileName(input: {
  candidateName: string | null;
  interviewId: string;
  uploadedAt: string | null;
  contentType: string | null;
}): string {
  const parts = [
    RECORDING_FILE_PREFIX,
    toFileNameSlug(input.candidateName),
    toTimestampSlug(input.uploadedAt),
    input.interviewId.slice(0, INTERVIEW_ID_SHORT_LENGTH),
  ].filter((part): part is string => part !== null);
  return `${parts.join("_")}${resolveRecordingExtension(input.contentType)}`;
}
